import { QuestionVariety } from "./Definition";
import { SingleValueQuestion } from "./SingleValueQuestion";

export default class PhotoUploadQuestion extends SingleValueQuestion {
  protected requiredErrorText = "Please upload a photo.";
  get type(): QuestionVariety {
    return "photo_upload";
  }
}
